export const ROLES = {
  flight: 'Flight',
  doco: 'Do&Co',
  admin: 'Admin',
  "doco-admin": 'Do&Co Admin',
  konnektom: "Konnektom Admin"
};
